import script from "./DialogAttendance.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogAttendance.vue?vue&type=script&setup=true&lang=ts"

import "./DialogAttendance.vue?vue&type=style&index=0&id=57475652&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57475652"]])

export default __exports__